import React, { useEffect, useState } from 'react';
import MainLayout from '../../Layout/MainLayout'
import BASEURL from '../../Config/global';
import axios from 'axios';
import PlaylistStrip from './PlaylistStrip';
import './style.css'
import { useDispatch } from 'react-redux';
import { handleCreatePlaylistModal } from '../../Store/Slices/ModalSlice';
import { OnRefresh } from '../../Services/RefreshObservable';
import { setCreatePlaylistType, setSelectedItem } from '../../Store/Slices/PlayerSlice';
import { useTranslation } from 'react-i18next';
import { translateEnglishToSpanishBatch } from '../../Util/translator';

const PlaylistScreen = () => {

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [playlists, setPlaylists] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    const sub = OnRefresh().subscribe((data) => {
      getDataByApi();
    });
    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    getDataByApi();
  }, [])


  const getDataByApi = async () => {
    try {
      const response = await axios.get(`${BASEURL}/api/user/playlists/`);
      if (response.data.data) {
        setCategoryList(response.data.default_playlist || []);
        const serverData = response.data.data;
        const names = serverData.map((item) => item.name) || [];

        if (i18n?.language === 'es' && names.length > 0) {
          try {
            const translateResult = await translateEnglishToSpanishBatch(names);
            if (translateResult.success && Array.isArray(translateResult.translatedTexts)) {
              const translatedTexts = translateResult.translatedTexts;
              const translatedData = serverData.map((item, idx) => ({
                ...item,
                // prefer translated name when available
                name: translatedTexts[idx] || item.name
              }));
              setPlaylists(translatedData);
              return;
            }
          } catch (err) {
            console.error('Batch translation failed', err);
          }
        }

        setPlaylists(serverData)
      }
      // setLoading(false)
    } catch (error) {
      // setLoading(false)
    }
  }

  const openCreatePlaylistModal = () => {
    dispatch(setSelectedItem([]));
    dispatch(setCreatePlaylistType('default'));
    dispatch(handleCreatePlaylistModal(true));
  }


  return (
    <>

      <MainLayout>
        <div className='playlist-layout'>
          <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
            <h1 className="pageTitle mb-0">{t("playlists.myPlaylists")}</h1>
            <div className='d-flex align-items-center justify-content-center'>
              <button
                style={{ backgroundColor: "#ffffff1f" }}
                className="px-4 py-2 smallText fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0"
                onClick={openCreatePlaylistModal}
              >
                <span>{t("playlists.createNewPlaylist")}</span>
              </button>
            </div>
          </div>
          {playlists?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <PlaylistStrip item={{ ...item, playlist_type: item.playlist_type, system_created_playlist: false }} />
              </React.Fragment>
            )
          })}
          {categoryList?.length > 0 && <hr />}
          {categoryList?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <PlaylistStrip item={{ ...item, playlist_type: item.playlist_type, system_created_playlist: true }} />
              </React.Fragment>
            )
          })}
        </div>
      </MainLayout>

    </>
  )
}

export default PlaylistScreen
